import { gql } from "apollo-boost";

export const GET_USER = gql`
  query user($id: ID!) {
    user(id: $id) {
      id
      emailId
      firstName
      lastName
      cellPhone
      dateOfBirth
      profilePic
      campaign
      isChef
      address {
        street1
        street2
        city
        state
        zip
      }
      equipments
      forceChangePassword
    }
  }
`;

export const GET_USER_PAYMENT = gql`
  query userPaymentMethods($userId: ID!) {
    userPaymentMethods(userId: $userId) {
      type
      card {
        cardId
        type
        last4
        expMonth
        expYear
      }
    }
  }
`;

//export const GET_SAVED_CHEFS = gql`#
//   query savedChefs($userId: ID!) {
//     savedChefs(userId: $userId) {
//       chefs {
//         id
//       }
//     }
//   }
// `;
// export const GET_SAVED_DISHES = gql`
//   query savedDishes($userId: ID!) {
//     savedDishes(userId: $userId) {
//       dishes {
//         id
//       }
//     }
//   }
// `;
//
// export const GET_SAVED_POSTS = gql`
//   query savedPosts($userId: ID!) {
//     savedPosts(userId: $userId) {
//       posts {
//         id
//       }
//     }
//   }
// `;

export const GET_SAVED_CHEFS = gql`
  query savedChefs(
    $userId: ID!
    $cursor: String
    $pageSize: Int
    $next: String
    $previous: String
  ) {
    savedChefs(
      userId: $userId
      cursor: $cursor
      pageSize: $pageSize
      next: $next
      previous: $previous
    ) {
      chefs {
        id
        emailId
        firstName
        lastName
        maxDiners
        minEngagementPrice
        cuisines
        active
        rating
        reviewCount
        profilePic
        verified  
      }
      endCursor
      hasMore
    }
  }
`;

export const GET_SAVED_DISHES = gql`
  query savedDishes(
    $userId: ID!
    $cursor: String
    $pageSize: Int
    $next: String
    $previous: String
  ) {
    savedDishes(
      userId: $userId
      cursor: $cursor
      pageSize: $pageSize
      next: $next
      previous: $previous
    ) {
      dishes {
        id
        name
        description
        cuisines
        isDraft
        minPrice
        minDinerSize
        equipmentNeeded
        numOfLikes
        chefName
        media {
          type
          url
        }
      }
      endCursor
      hasMore
    }
  }
`;

export const GET_SAVED_POSTS = gql`
  query savedPosts(
    $userId: ID!
    $cursor: String
    $pageSize: Int
    $next: String
    $previous: String
  ) {
    savedPosts(
      userId: $userId
      cursor: $cursor
      pageSize: $pageSize
      next: $next
      previous: $previous
    ) {
      posts {
        id
        chefId
        title
        blurb
        body
        isDraft
        createdAt
        updatedAt
        tags
        chefName
        numOfLikes
        media {
          type
          url
        }
      }
      endCursor
      hasMore
    }
  }
`;

export const GET_CHAT_USERS = gql`
  query getChatUsers($id: ID!, $isChef: Boolean!) {
    getChatUsers(id: $id, isChef: $isChef) {
      id
      firstName
      lastName
      profilePic
    }
  }
`;

export const USER_PROFILE = gql`
  query userProfile($userId: ID!) {
    userProfile(userId: $userId) {
      id
      emailId
      firstName
      lastName
      cellPhone
      profilePic
      dateOfBirth
      address {
        street1
        street2
        city
        state
        zip
        country
      }
    }
  }
`;

export const USER_REVIEW = gql`
  query reviewTagsForChef($userId: ID!) {
    reviewTagsForChef(userId: $userId)
  }
`;

export const CHEF_REVIEW = gql`
  query reviewTagsForUser($userId: ID!) {
    reviewTagsForUser(userId: $userId)
  }
`;
